import { useEffect, useState } from 'react';
import { BOOKING_URL } from '../../lib/constants';
import { Calendar } from 'lucide-react';

export const FloatingCTA = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-book-cta"
      aria-label="Book your lash lift"
      className={`fixed sm:hidden bottom-20 left-1/2 -translate-x-1/2 z-40 transition-all duration-500 ${
        show ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
    >
      <div className="flex items-center gap-2 bg-brand-gold text-brand-ink pl-5 pr-3 py-3 rounded-full shadow-2xl border border-brand-goldWarm">
        <span className="text-sm font-semibold tracking-wide">Book Your Lash Lift</span>
        <span className="w-9 h-9 rounded-full bg-brand-ink text-brand-gold flex items-center justify-center">
          <Calendar size={16} />
        </span>
      </div>
    </a>
  );
};

export default FloatingCTA;
